export const sidebarMenus = [
  {
    id: 'discovery-details',
    label: 'Discovery Details',
    url: '/agency/discovery',
  },
  {
    id: 'yucollect-documents',
    label: 'Yucollect Documents',
    url: '/agency/yucollect-documents',
  },
  {
    id: 'allocators-documents',
    label: 'Allocator’s Documents',
    isMenu: false,
    menuItems: [],
  },
];

export const YUCOLLECT_ADMIN_GROUP = 'yucollect_ops';
export const ALLOCATOR_GROUP = 'allocator';

export const ALLOCATOR = 'ALLOCATOR';
export const ALLOCATOR_MASTER = 'ALLOCATOR_MASTER';

export const UPLOAD = 'UPLOAD';
export const EDIT = 'EDIT';
export const VIEW = 'VIEW';

export type CompanyTypeKey =
  | 'proprietary'
  | 'partnership'
  | 'private_ltd'
  | 'llp'
  | 'huf'
  | 'all';

export const COMPANY_TYPE: Record<CompanyTypeKey, string> = {
  proprietary: 'Sole proprietorship',
  partnership: 'Partnership',
  private_ltd: 'Company',
  llp: 'LLP',
  huf: 'HUF',
  all: 'All',
};
